import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { getUniversityDomains } from '@/api/internal'
import DomainListTable, { DomainRow } from '@/pages/app/DomainManagement/components/DomainListTable'

export const UNIVERSITY_DOMAINS_QUERY_KEY = ['universityDomains'] as const

const UniversityDomainList = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: UNIVERSITY_DOMAINS_QUERY_KEY,
    queryFn: async () => (await getUniversityDomains()).data,
  })

  const rows: DomainRow[] = useMemo(() => (data?.domains ?? []).map((domain) => ({ domain })), [data])

  return (
    <DomainListTable
      rows={rows}
      isLoading={isLoading}
      hasError={!!error}
      listName="university domains"
      banner={
        <>
          Domains belonging to universities and academic institutions, used to recognize educational accounts during
          domain checks. This list is read-only — it&apos;s maintained in the backend&apos;s university domain config.
          {data?.last_updated ? ` Last updated ${data.last_updated}.` : ''}
        </>
      }
      totalChip={`${(data?.total ?? 0).toLocaleString()} domains`}
    />
  )
}

export default UniversityDomainList
